import { request } from '@/shared/api/request'
export const findOrg = (iinOrBin) => request({ url: `user/find/org/${iinOrBin}`, method: 'GET' })
